<template>
  <v-card class="elevation-0 mt-8">
      
      <v-divider></v-divider>
      <v-row class="mx-2 mb-3">
        <v-col cols="12" md="6">
          <v-card class=" outlined" flat>
            <strong>
              {{$vuetify.lang.t('$vuetify.access_tab.group_invitation')}}
            </strong>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="justify-end mt-1">
            <Button
              :buttonType="FLOATING_ACTION_BUTTON"
              iconName="mdi-plus"
              size="x-small"
              :buttonText="$vuetify.lang.t('$vuetify.access_tab.create_group_invitation')"
              color="primary"
              :disabled="!$hasProjectAccessFor([$pRole.ADMIN]) || assignedMembersLoading"
              @onClick="openGroupInvitationModal()"
            />
          </v-row>
        </v-col>
      </v-row>
      <Loader v-if="isLoading" class="mr-2 mt-6" />
      <v-data-table
        v-else
        :items="invitations"
        class="elevation-1 mt-6"
        :headers="groupInvitationHeaders"
        outlined
        show-expand
        :sort-by="['created_at']"
        :sort-desc="[true]"
        
      >
        <template v-slot:[`item.url`]="{ item }">
          <span>{{ item.jti }}</span>
        </template>
        <template v-slot:[`item.tags`]="{ item }">
          <div>
            <v-chip
              v-for="(tag, index) in item.tags.slice(0, 2)"
              :key="index"
              class="ma-1"
              color="primary"
              small
              dark
            >
              {{ tag }}
            </v-chip>
            <span v-if="item.tags.length > 2">+{{ item.tags.length - 2 }} more</span>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <ButtonGroup
            :groupType="ACTION_BUTTON_GROUP"
            :detailsButton="false"
            :addButton="false"
            :deleteButton="false"
            
            :editButton="true"
            :disabledEditButton="!$hasProjectAccessFor([$pRole.ADMIN])"
            @onEditClick="editInvitation(item)" 

            :stopButton="item.status == 'active'"
            :disabledStopButton="!$hasProjectAccessFor([$pRole.ADMIN])"
            @onStopClick="disableInvitation(item)"
            
            :startButton="item.status == 'inactive'"
            :disabledStartButton="!$hasProjectAccessFor([$pRole.ADMIN])"
            @onStartClick="enableInvitation(item)"               
          />
        </template>

        <template v-slot:item.created_at="{ item }">
              {{ item.created_at ? formatDateTime(item.created_at) : "N/A" }}
        </template>
        <template v-slot:expanded-item="{ item }">
            <td :colspan="groupInvitationHeaders.length">
              <v-row>
                <v-col cols="12" >
                  <div class="text-subtitle-2 font-weight-medium mb-1">
                    {{$vuetify.lang.t('$vuetify.access_tab.invitation_url')}}
                  </div>
                  <v-text-field
                    :value="`${MairaPlayGroundUrl}/${item.jti}`"
                    readonly
                    dense
                    outlined
                    hide-details
                    variant="outlined"
                    class="copy-field"
                    append-icon="mdi-content-copy"
                    @click:append="copyToClipboard(`${MairaPlayGroundUrl}/${item.jti}`)"
                  />
                </v-col>
                <v-col cols="12">
                    <div class="text-subtitle-2 font-weight-medium mb-1">
                      {{$vuetify.lang.t('$vuetify.access_tab.tags')}}
                    </div>
                    <v-chip-group column>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        class="ma-1"
                        color="primary"
                        small
                        dark
                      >
                        {{ tag }}
                      </v-chip>
                    </v-chip-group>
                </v-col>
              </v-row>
            </td>
            
        </template>

      </v-data-table>
      <v-dialog persistent v-model="groupInvitationDialog" width="60%">
        <v-card class="pa-8">
          <v-skeleton-loader
            v-if="checkingProfiles"
            type="article, actions"
          ></v-skeleton-loader>
          <template v-else>
          <v-row>
            <v-col>
              <div class="py-4 primary--text font-weight-bold">
                {{editGroupInvitation ? $vuetify.lang.t('$vuetify.access_tab.update_invitation_url') : $vuetify.lang.t('$vuetify.access_tab.create_public_invitation_url') }}
              </div>
            </v-col>
          </v-row>
          <v-form  ref="group_invitation_form" lazy-validation>
            <v-row align="center" v-if="inviteUrl">
              <v-col>
                <v-text-field
                    :value="inviteUrl"
                    readonly
                    dense
                    outlined
                    :label="$vuetify.lang.t('$vuetify.access_tab.invitation_url')"
                    hide-details
                    variant="outlined"
                    class="copy-field"
                    append-icon="mdi-content-copy"
                    @click:append="copyToClipboard(inviteUrl)"
                  />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="title"
                  dense
                  outlined
                  clearable
                  hide-details="auto"
                  :label="$vuetify.lang.t('$vuetify.access_tab.title')"
                  :placeholder="$vuetify.lang.t('$vuetify.access_tab.title_placeholder')"
                  :disabled="isLoading || (inviteUrl !== '' && !editGroupInvitation)"
                />
              </v-col>
            </v-row>
            <v-row >
              <v-col>
                <v-combobox
                  v-model="tags"
                  :items="[]"
                  :label="$vuetify.lang.t('$vuetify.access_tab.tags')"
                  variant="solo"
                  clearable
                  outlined
                  multiple
                  dense
                  closable
                  :append-icon="null"
                  @change="onTagsChange"
                  :placeholder="$vuetify.lang.t('$vuetify.access_tab.tags_placeholder')"
                  :hint="$vuetify.lang.t('$vuetify.gpt_profile.chip_hint')"
                  class="no-dropdown-icon"
                  :disabled="isLoading || (inviteUrl != '' && !editGroupInvitation)"
                >
                  <template v-slot:selection="{ attrs, item, select,  selected }">
                    <v-chip v-bind="attrs" small :model-value="selected" @click="select" @click:close="removeTag(item)" close>
                      <span>{{ item }}</span
                      >&nbsp;
                    </v-chip>
                  </template>
                </v-combobox>
                  <v-alert
                    v-if="profilesUsingInvitation.length > 0"
                    type="warning"
                    dense
                    outlined
                    class="mt-2"
                    icon="mdi-alert"
                  >
                    {{ $vuetify.lang.t('$vuetify.access_tab.invitation_url_used_in_profiles_prefix') }}
                    <strong>{{ profilesUsingInvitation.map(p => p.name).join(', ') }}</strong>. 
                    {{ $vuetify.lang.t('$vuetify.access_tab.invitation_url_used_in_profiles_suffix') }}
                  </v-alert>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col>
              <v-card-actions class="justify-start justify-sm-end pa-0">
                <v-btn @click="closeGroupInvitationModal" outlined color="error">
                  {{$vuetify.lang.t('$vuetify.common.close_btn')}}
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="() => editGroupInvitation ? updateGroupInvitation() : createGroupInvitation()"
                  :loading="isLoading"
                  v-if="!inviteUrl || editGroupInvitation"
                >
                  {{ editGroupInvitation ? $vuetify.lang.t('$vuetify.common.update_btn') : $vuetify.lang.t('$vuetify.common.create') }}
                  <v-progress-circular v-if="isLoading" indeterminate color="white"></v-progress-circular>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
          </template>
        </v-card>
      </v-dialog>
    </v-card>
</template>

<script>
//  TODO: apply this {{$vuetify.lang.t('$vuetify.access_tab.enable')}} to train button in line no... 74 to 76
import { mapState, mapActions } from "vuex";
import Button from "@/components/common/button/Button";
import { ACTION_BUTTON_GROUP } from "@/components/common/buttongroup/_buttongrouptypes";
import {
FLOATING_ACTION_BUTTON,
} from "@/components/common/button/_buttontypes";
import {
LOAD_ALL_MEMBERS,
ASSIGN_PROJECT_MEMBERS,
RETRIEVE_PROJECT_MEMBERS,
DELETE_PROJECT_MEMBERS,
ADD_ALERT,
GENERATE_PUBLIC_INVITATION_URL,
GET_PUBLIC_INVITATIONS_LIST,
UPDATE_PUBLIC_INVITATION_URL,
GET_GPT_PROFILE_BY_ID,
GET_GPT_PROFILES,
} from "@/store/_actiontypes";
import Loader from "@/components/common/loader/Loader";
// import DialogModal from "@/components/common/DialogModal";
import ButtonGroup from "@/components/common/buttongroup/ButtonGroup";
import getEnv from "@/config/env";
import {
  capitalizeFirstLetter,
  formatDateTime,
} from "@/helpers/helper";

export default {
props: {

},
components: {
  // eslint-disable-next-line vue/no-reserved-component-names
  Button,
  // eslint-disable-next-line vue/no-reserved-component-names
  // DialogModal,
  Loader,
  ButtonGroup
}, 
computed: {
  ...mapState({
    allMembers: state => state.member.allMembers,
    selectedProject: state => state.project.selectedProject,
    projectId : state => state.project.selectedProject?.id,
    organization: state => state.account.organization,
  }),
},
mounted(){
  this.getPublicInvitations()
  this.loadEnvs()
},
data(){
  return {
    FLOATING_ACTION_BUTTON: FLOATING_ACTION_BUTTON,
    groupInvitationDialog : false,
    isLoading: false,
    selectedMembers: [],
    memberConfirmationModal: false,
    memberRemoveConfirmationModal: false,
    selectedProjectMembers: [],
    assignedMembersLoading: false,
    projectMembers: [],
    MairaPlayGroundUrl: "",
    selectedGroupInvitation: {},
    title: "",
    tags: [],
    inviteUrl: "",
    editGroupInvitation: false,
    invitations: [],
    formatDateTime,
    profilesUsingInvitation: [],
    checkingProfiles: false,
    groupInvitationHeaders: [
        {
          text: this.$vuetify.lang.t("$vuetify.access_tab.url_identifier"),
          value: "url",
          sortable: true,
          align: "start",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.access_tab.title"),
          value: "title",
          sortable: true,
          align: "start",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.access_tab.tags"),
          align: "start",
          sortable: true,
          value: "tags",
          cellClass: "d-inline-inherit",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.status"),
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.access_tab.joined_members"),
          align: "center",
          sortable: true,
          value: "joined",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.created_at"),
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.catalog.actions"),
          align: "start",
          sortable: true,
          value: "actions",
        },
    ],
    ACTION_BUTTON_GROUP
  }
},
methods: {
  ...mapActions("member", [
    LOAD_ALL_MEMBERS,
    GENERATE_PUBLIC_INVITATION_URL,
    GET_PUBLIC_INVITATIONS_LIST,
    UPDATE_PUBLIC_INVITATION_URL
  ]),
  ...mapActions("project", [
    ASSIGN_PROJECT_MEMBERS,
    RETRIEVE_PROJECT_MEMBERS,
    DELETE_PROJECT_MEMBERS,
    GET_GPT_PROFILE_BY_ID,
    GET_GPT_PROFILES,
  ]),
  ...mapActions("alert", [ADD_ALERT]),
  openGroupInvitationModal() {
    this.groupInvitationDialog = true
  },
  isProjectMember(memberId){
    return this.projectMembers.some(projectMember => projectMember.user_id === memberId)
  },
  closeGroupInvitationModal(){
    this.groupInvitationDialog = false
    this.editGroupInvitation = false
    this.inviteUrl = ""
    this.selectedGroupInvitation = {}
    this.tags = []
    this.title = ""
    this.profilesUsingInvitation = []
  },
  loadEnvs(){
    this.MairaPlayGroundUrl  = `${getEnv("VUE_APP_MAIRA_APP_URL")}/register`
  },
  showMemberAssignmentConfirmationModal(){
      this.memberConfirmationModal = true
      this.newProjectMemberDialog = false
  },
  disableInvitation(item){
    
    this.selectedGroupInvitation = item
    this.tags = item.tags
    this.updateGroupInvitation("inactive")
  },
  enableInvitation(item){
    this.tags = item.tags
    this.selectedGroupInvitation = item
    this.updateGroupInvitation("active")
  },
  editInvitation(item){
    this.editGroupInvitation = true
    this.groupInvitationDialog = true
    this.tags = item.tags || []
    this.title = item.title || ""
    this.selectedGroupInvitation = item
    this.inviteUrl = `${this.MairaPlayGroundUrl}/${item.jti}`
    this.checkInvitationInProfiles(item.jti);
  },
  isProjectOwner(id){
    if(this.selectedProject.owner?.id === id){
      return true
    } 
    return false
  },
  createGroupInvitation(){
    const projectId = this.selectedProject.id
    this.isLoading = true
    this.GENERATE_PUBLIC_INVITATION_URL({projectId, tags: this.tags, title: this.title}).
    then(res => {
      this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: this.$vuetify.lang.t("$vuetify.access_tab.create_group_invitation_successful"),
                color: 'success',
              },
              { root: true }
      );
      this.inviteUrl = `${this.MairaPlayGroundUrl}/${res.data.code}`
      this.getPublicInvitations()
    }).
    catch(e=> {
      this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: e.response?.data?.message,
                color: 'error',
              },
              { root: true }
            );
      console.error("Error", e)
    }).finally(()=> {
      this.isLoading = false
    })

  },
  getPublicInvitations(){ 
    this.isLoading = true
    const projectId = this.selectedProject.id
    this.GET_PUBLIC_INVITATIONS_LIST({projectId}).
    then(res => {
      this.invitations = res.data.invitations
    }).catch((e)=> {
      console.error("Error", e)
    }).finally(()=> {
      this.isLoading = false
    })

  },
  updateGroupInvitation(status = null){
    this.isLoading = true
    let payload = {
      tags: this.tags,
      title: this.title
    }
    if(status){
      payload["status"] = status
    }
    const projectId = this.selectedProject.id
    this.isLoading = true
    this.UPDATE_PUBLIC_INVITATION_URL({projectId, payload, invitationId: this.selectedGroupInvitation.id}).
    then(res => {
      if(res.status === 200){
        this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: this.$vuetify.lang.t("$vuetify.access_tab.group_invitation_successful"),
                color: 'success',
              },
              { root: true }
            );
      }
      this.closeGroupInvitationModal()
      this.getPublicInvitations()
    }).
    catch(e=> {
      this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: e.response?.data?.message,
                color: 'error',
              },
              { root: true }
            );
      console.error("Error", e)
    }).finally(()=> {
      this.isLoading = false
    })
  },
  onTagsChange(val) {
      const trimmed = val.map(tag => tag.trim()).filter(tag => tag !== "");
      this.tags = Array.from(new Set(trimmed));
  },
  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(
        () => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t("$vuetify.access_tab.invitation_url_copy"),
              color: 'success',
            },
            { root: true }
          );
        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
  },
  removeTag(item) {
      this.tags.splice(this.tags.indexOf(item), 1)
  },
  async checkInvitationInProfiles(jti) {
    this.checkingProfiles = true;
    this.profilesUsingInvitation = [];
    
    try {
      const profilesResponse = await this.GET_GPT_PROFILES({
        project_id: this.projectId,
        start: 0,
        size: 100
      });
      
      const profiles = profilesResponse?.data?.detail?.response?.profiles || [];

      // Filter profiles that use this invitation
      this.profilesUsingInvitation = profiles
        .filter(profile => {
          const groupInvitationToken = profile.liff_endpoint_url_config?.group_invitation_token;
          return groupInvitationToken === jti;
        })
        .map(profile => ({
          id: profile.id,
          name: profile.name
        }));
    } catch (error) {
      console.error('Error fetching profiles:', error);
      this.profilesUsingInvitation = [];
    } finally {
      this.checkingProfiles = false;
    }
  }
}
}

</script>

<style>
</style>